module.exports = __webpack_public_path__ + "static/media/logo.33dc88d3.png";